import * as React from "react"
import * as TogglePrimitive from "@radix-ui/react-toggle"

import { cn } from "@/lib/utils"

type ToggleProps = React.ComponentPropsWithoutRef<typeof TogglePrimitive.Root>

const Toggle = React.forwardRef<React.ElementRef<typeof TogglePrimitive.Root>, ToggleProps>(
  ({ className, ...props }, ref) => (
    <TogglePrimitive.Root
      ref={ref}
      className={cn(
        "inline-flex items-center justify-center rounded-md border border-border bg-background/40 px-3 py-1.5 text-sm font-medium text-foreground/80 ring-offset-background transition-all duration-200 hover:bg-muted hover:text-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 data-[state=on]:border-primary data-[state=on]:bg-primary/15 data-[state=on]:text-foreground",
        className,
      )}
      {...props}
    />
  ),
)
Toggle.displayName = TogglePrimitive.Root.displayName

export { Toggle }
